export const ROOT = 'headBand';

export const FETCH_HEADBAND_REQUEST = `${ROOT}/FETCH_HEADBAND_REQUEST`;
export const FETCH_HEADBAND_FAILURE = `${ROOT}/FETCH_HEADBAND_FAILURE`;
export const FETCH_HEADBAND_SUCCESS = `${ROOT}/FETCH_HEADBAND_SUCCESS`;


export const SHOW_HEADBAND = `${ROOT}/SHOW_HEADBAND`;
export const HIDE_HEADBAND = `${ROOT}/HIDE_HEADBAND`;
